const tabs = {
  categories: [
    { id: 'all', name: 'All' },
    { id: 'live', name: 'LIVE' },
  ],
};

export default tabs;
